export default "__VITE_ASSET__iRbgJOnZ__"